export default __webpack_public_path__ + "static/media/project-wizard-in-app-contents.4a807059.png";